/* ------------------------------------------------------------------
   Saving a file the server sends.

   fetch rather than a plain link, because the request has to carry the
   signed-in user's token (added by the wrapper in api.js), and a link
   cannot. The browser is then handed what came back, under the name the
   server gave it, by way of a link that is clicked and removed.
   ------------------------------------------------------------------ */
export async function downloadFile(url, fallbackName = 'download') {
  const r = await fetch(url);
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error(body.error || 'The download did not work. Try again.');
  }
  const blob = await r.blob();
  const match = /filename="([^"]+)"/.exec(r.headers.get('Content-Disposition') || '');
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = match ? match[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}
